/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        heading: {
            fontSize: '2xl'
        },
        addPaymentBtn: {
            border: '1px dashed',
            borderColor: 'gray.200',
            color: 'blue.600',
            variant: 'outline',
            height: {lg: 'full'},
            minHeight: 11,
            fontWeight: 'medium',
            rounded: 'base'
        },
        addPaymentBtnIcon: {
            display: 'block',
            boxSize: '15px'
        },
        grid: {
            columns: [1, 2, 2, 2, 3],
            spacing: 4,
            gridAutoFlow: 'row dense'
        },
        ccFormWrapper: {
            border: '1px solid',
            borderColor: 'gray.100',
            rounded: 'base',
            overflow: 'hidden'
        },
        ccFormHeadingWrapper: {
            py: 3,
            px: [4, 4, 6],
            bg: 'gray.50',
            borderBottom: '1px solid',
            borderColor: 'gray.100'
        },
        ccFormInputWrapper: {
            p: [4, 4, 6],
            borderBottom: '1px solid',
            borderColor: 'gray.100'
        },
        ccFormInputBox: {
            spacing: 6,
            height: 35,
            p: 2,
            borderWidth: '2px',
            borderColor: 'gray.400'
        },
        ccFormBtnWrapper: {
            pt: 3,
            display: 'flex',
            justifyContent: 'end'
        }
    })
}
